import React from 'react';
import {Form} from "../lib/Form";

//TODO Validation & error handling
//TODO set keyboard

export default function MailForm({message={},...props}){

    const fields = [
        {
            id: 'to',
            decorator: {
                rules: [{
                    type: 'email',
                    required: true,
                    whitespace: true,
                    message: 'to email required'
                }],
                initialValue: message.to,
            },
            label: 'To',
            type: 'email'
        },
        {
            id: 'from',
            decorator: {
                rules: [{
                    required: true,
                    whitespace: true,
                    message: 'from required'
                }],
                initialValue: message.from,
            },
            label: 'From (name)'
        },
        {
            id: 'replyTo',
            decorator: {
                rules: [{
                    type: 'email',
                    required: true,
                    whitespace: true,
                    message: 'reply to email required'
                }],
                initialValue: message.replyTo,
            },
            label: 'Reply to (email)',
            type: 'email'
        },
        {
            id: 'bcc',
            decorator: {
                initialValue: message.bcc,
            },
            label: 'BCC Reply to',
            type: 'CheckboxItem'
        },
        {
            id: 'subject',
            decorator: {
                rules: [{
                    required: true,
                    whitespace: true
                },{
                    max: 78,
                    message: 'subject too long'
                }],
                initialValue: message.subject,
            },
            label: 'Subject',
            type: 'TextareaItem',
            rows: 2
        },
        {
            id: 'message',
            decorator: {
                rules: [{
                    required: true,
                    whitespace: true,
                    message: 'message required'
                }],
                initialValue: message.body,
            },
            label: 'Message',
            type: 'TextareaItem',  //TODO ? pass componemt type  - clone?
            rows: 0  // ?not respected on Android
        }
    ];

    return (
        <Form
            fields={fields}
            headerText={'Email details'}
            submitText={'Send'}
            resetText={'Undo'}
            labelNumber={6}
            {...props} />
    );
}